<template>
  <div>
    <img
      loading="lazy"
      class="flex mx-4 md:mx-6"
      src="~/assets/images/linkedin.png"
      alt="linkedin"
      width="38"
      height="39"
      v-if="icon == 'linkedin'"
    />
    <img
      loading="lazy"
      class="flex mx-4 md:mx-6"
      src="~/assets/images/facebook.png"
      alt="facebook"
      width="39"
      height="39"
      v-if="icon == 'facebook'"
    />
    <img
      loading="lazy"
      class="flex mx-4 md:mx-6"
      src="~/assets/images/twitter.png"
      alt="twitter"
      width="39"
      height="32"
      v-if="icon == 'twitter'"
    />
    <img
      loading="lazy"
      class="flex mx-4 md:mx-6"
      src="~/assets/images/youtube.png"
      alt="youtube"
      width="38"
      height="28"
      v-if="icon == 'youtube'"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  icon: String,
});
</script>


<style scoped>
</style>